import {BASE_URL_PLACEHOLDER} from '@/utils/constants/apiEndPoints';
import {FeatureConfig, FeatureToggle} from '@/utils/constants/featuresFlag';
import {getCountries} from '@/helpers/envConfig';
import {isFeatureEnabled} from '@/helpers/featureToggle';
import axios, {AxiosError, HttpStatusCode} from 'axios';
import {ROUTES} from '@/utils/constants/routesConstants';
import {logger} from '@/helpers/logger';

export const HTTPMethod = {
  DELETE: 'DELETE',
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT'
};

export const ContentType = {
  APPLICATION_JSON: 'application/json',
  MULTIPART_FORMDATA: 'multipart/form-data'
};

const onUnauthorisedError = async () => {
  // await oktaAuth.signOut();
};

export const handleNetworkErrors = async (error) => {
  const isCanceled = error.code === AxiosError.ERR_CANCELED;

  if (isCanceled) return Promise.reject(error);

  const isUnauthorized = error.response?.status === HttpStatusCode.Unauthorized;
  const isForbidden = error.response?.status === HttpStatusCode.Forbidden;
  const isNetworkError = error.code === AxiosError.ERR_NETWORK;

  if (isForbidden) {
    window.location.href = ROUTES.ERROR_403;
  } else if (isUnauthorized || isNetworkError) {
    try {
      await onUnauthorisedError();
    } catch (signOutError) {
      logger.error('onUnauthorisedError::ERROR', signOutError);
    }
    // window.location.reload();
  }

  return Promise.reject(error);
};

const axiosiInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});
axiosiInstance.interceptors.request.use(
  (config) => config,
  (error) => handleNetworkErrors(error)
);
axiosiInstance.interceptors.response.use(
  (response) => response,
  (error) => handleNetworkErrors(error)
);

export default function api({
  method = HTTPMethod.GET,
  contentType = ContentType.APPLICATION_JSON,
  path,
  signal,
  onUploadProgress
}) {
  return (requestData) => {
    async function apiCall() {
      const {url, baseURL, isAdminPortalUrl} = pathAdapter(path);

      const shouldSendCountryHeader =
        !isAdminPortalUrl && isFeatureEnabled(FeatureToggle.countryHeader);

      const response = await axiosiInstance.request({
        signal,
        baseURL,
        url,
        headers: {
          // Authorization: oktaAccessToken(),
          country: shouldSendCountryHeader ? getCountries()[0] : undefined,
          'Content-Type': contentType
        },
        method,
        [method === HTTPMethod.GET ? 'params' : 'data']: requestData,

        onUploadProgress: (progressEvent) => onUploadProgress?.(progressEvent)
      });
      return response;
    }

    return apiCall();
  };
}

const pathAdapter = (path) => {
  let baseURL = import.meta.env[FeatureConfig.apiUrl];

  const adminPortalPlaceholder = BASE_URL_PLACEHOLDER.ADMIN_PORTAL;
  const isAdminPortalUrl = path.includes(adminPortalPlaceholder);
  if (isAdminPortalUrl) {
    baseURL = import.meta.env[FeatureConfig.apiAdminUrl];
  }

  const realTimeEventsPlaceholder = BASE_URL_PLACEHOLDER.EVENTS;
  const isRealTimeEventsUrl = path.includes(realTimeEventsPlaceholder);
  if (isRealTimeEventsUrl) {
    baseURL = import.meta.env[FeatureConfig.apiEventsUrl];
  }

  const url = path
    .replace(adminPortalPlaceholder, '')
    .replace(realTimeEventsPlaceholder, '');

  return {
    url,
    baseURL,
    isAdminPortalUrl,
    isRealTimeEventsUrl
  };
};
